import { render, staticRenderFns } from "./CalendarCategoriesDropdown.vue?vue&type=template&id=5a8391c4&"
import script from "./CalendarCategoriesDropdown.vue?vue&type=script&lang=js&"
export * from "./CalendarCategoriesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports